import React from 'react';

/**
 * Shared vertical layout for a single wizard step.
 *
 * Title + optional description at the top, scrollable body below.
 * Keeps spacing and type scale consistent across all steps.
 */
const StepShell = ({ title, description, children }) => (
  <div className='flex flex-col gap-5'>
    <div>
      <h2 className='font-display text-xl leading-tight mb-1.5'>{title}</h2>
      {description && <p className='text-[13px] text-muted-foreground leading-relaxed'>{description}</p>}
    </div>
    <div className='space-y-5'>{children}</div>
  </div>
);

export default StepShell;
